import { http } from '../http';
import { getSignedDocumentDownloadUrl } from './get-signed-document-download-url';

export async function getSigningRequestDocument(
	authorUlid: string,
	documentUlid: string,
	documentName: string,
) {
	const signedDocumentDownloadUrl = await getSignedDocumentDownloadUrl(
		`${authorUlid}/${documentUlid}/signed/${documentName}`,
	);
	if (signedDocumentDownloadUrl) {
		const documentBlob = await http.getBlob(signedDocumentDownloadUrl);
		if (documentBlob) {
			const signedDocument = new File(
				[documentBlob],
				'signed-document.pdf',
			);
			return signedDocument;
		} else {
			throw TypeError();
		}
	} else {
		throw new Error('Failed getting signed document download URL');
	}
}
